import type { ReactElement } from 'react'
import { featureHidden, type AlphaFeature } from '@mfox/shared/lib/alpha'
import { ComingSoonPage } from './ComingSoonPage'

/** A route's element, or Coming soon when this build hides its feature. Use where the route is declared. */
export function gated(feature: AlphaFeature, element: ReactElement): ReactElement {
  return featureHidden(feature) ? <ComingSoonPage /> : element
}
